/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

 import React, { Component } from 'react';
 import { BrowserRouter as Router, Route, withRouter } from 'react-router-dom';
 import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
 import { LoginCallback, Security, SecureRoute } from '@okta/okta-react';
 import Home from './Home';
 
 const oktaAuth = new OktaAuth({
   issuer: 'https://id-sbx.resmed.com/oauth2/default',
   clientId: '0oa12ypkp7uYjOlLR0h8',
   redirectUri: window.location.origin + '/login/callback'
 });
 
 class App extends Component {
 
   constructor(props) {
     super(props);
     this.restoreOriginalUri = async (_oktaAuth, originalUri) => {
       props.history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
     };
   }
 
   render() {
     return (
       <Security oktaAuth={oktaAuth} restoreOriginalUri={this.restoreOriginalUri}>
         <SecureRoute path="/" exact={true} component={Home}/>
         <Route path="/login/callback" component={LoginCallback}/>
       </Security>
     );
   }
 }
 
 const AppWithRouterAccess = withRouter(App);
 
 class RouterApp extends Component {
   render() {
     return (<Router><AppWithRouterAccess/></Router>);
   }
 }
 
 export default RouterApp;



